import { initialNextState, INextState } from '../state/next.state';
import { ENextActions, NextActions } from '../actions/next.actions';

export const nextReducers = (
    state = initialNextState,
    action: NextActions
  ): INextState => {
    switch (action.type) {
      case ENextActions.GetNextSuccess: {
        return {
          ...state,
          next: action.payload
        };
      }
      default:
        return state;
    }
  };
